export default __webpack_public_path__ + "static/media/modern-background.324d1f0f.jpg";